<template>
  <div class="produto-cdlsaude-planos">
    <div class="content">
      <Titulo
        class="py-4"
        :title="'Escolha de Plano'"
        description="Selecione o plano que se encaixa na sua empresa."
      />
      <ListaPlanos :list="planos" @click="salvar" />
      <div class="row mt-5">
        <div class="col-md-4 col-lg-2">
          <Botao
            title="Voltar"
            :link="linkVoltar"
            nameClass="btn btn-outline-secondary btn-lg btn-block"
            >VOLTAR</Botao
          >
        </div>
      </div>
    </div>
    <div class="py-5"></div>
  </div>
</template>
<script>
import Titulo from "@/components/TituloPaginas";
import ListaPlanos from "@/components/planos/ListaPlanosConciliador";
import Botao from "@/components/botoes/Botao";

export default {
  name: "Planos",
  components: {
    Titulo,
    ListaPlanos,
    Botao,
  },
  data() {
    return {
      produto: {
        nome: "SPC Conciliador",
        id: "SPC Conciliador",
      },
      breadcrumb: [
        {
          nome: "SPC Conciliador",
          id: "spc-conciliador",
          link: "/produto/spc-conciliador/painel",
        },
        {
          nome: "Lista de Planos",
          id: "plano_conciliador",
        },
      ],
      planos: [],
      linkVoltar: "/produto/spc-conciliador/painel",
    };
  },
  methods: {
    salvar(payload) {
      let dadosPlano = this.planos.find(
        (el) => el.cod == payload.dados.planoSel
      );

      let registro = {
        dadosPlano: dadosPlano,
        qtdCnpj: payload.dados.qtdCnpj,
        operadoras: payload.dados.operadoras,
      };

      const parsed = JSON.stringify(registro);
      localStorage.setItem("spc_conciliador", parsed);
      this.$router.push({ name: "resumo-conciliador" });
    },
    carregarPlanos() {
      this.$http
        .get("/api/Conciliador/ConsultarPlanosSpcConciliador")
        .then((response) => {
          if (response.data.length > 0) {
            response.data.forEach((el) => {
              let dadosPlano = {
                cod: el.planoId,
                nome: el.descricao,
                adesao: el.taxaAdesao,
                mensalidade: el.mensalidade,
                qtdCnpj: el.qtdeCnpjs,
                qtdAdquirentes: el.adquirentes,
                qtdTransacoes: el.transacoes,
                transacoesExcedentes: el.excedentes,
                adquirenteExra: el.adquirentesExtra,
                custoOperadoras: el.custoOperadoras,
                filialExtra: el.filialExtra,
              };
              this.planos.push(dadosPlano);
            });
          } else {
            this.$router.push({ name: "intitucional" });
          }
        })
        .catch((error) => {
          if (error.response.status === 400) {
            this.$toast.open({
              message: error.response.data.mensagem,
              type: "warning",
            });
            this.$router.push({ name: "painel-conciliador" });
          }
          if (error.response.status === 401) {
            this.$router.push({ name: "login" });
          }

          this.loading = false;
          this.error = error.response.data.mensagem;
        });
    },
  },
  mounted() {
    this.carregarPlanos();
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
  },
};
</script>
